import React, { useRef, useEffect, useState } from "react";

const VideoThumbnail = ({ file }) => {
  console.log(file, "episode file");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const handleLoadedMetadata = () => {
      video.currentTime = 10; // Set to the time of the frame you want to capture
    };

    const handleSeeked = () => {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL();
      setThumbnail(imageUrl);
    };

    if (file) {
      const videoURL = URL.createObjectURL(file);
      video.src = videoURL;

      video.addEventListener("loadedmetadata", handleLoadedMetadata);
      video.addEventListener("seeked", handleSeeked);

      return () => {
        video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        video.removeEventListener("seeked", handleSeeked);
        URL.revokeObjectURL(videoURL);
      };
    }
  }, [file]);

  return (
    <div>
      <video ref={videoRef} style={{ display: "none" }} />
      <canvas
        ref={canvasRef}
        width={320}
        height={180}
        style={{ display: "none" }}
      />
      {thumbnail && <img src={thumbnail} alt="Video Thumbnail" />}
    </div>
  );
};

export default VideoThumbnail;
